  import { createStore } from 'vuex'

  const store = createStore({
    state () {
      return {
        forceLeave: false,
      }
    },
    mutations: {
      forceLeave(state){
        state.forceLeave = !state.forceLeave;
      }
    },
    getters:{
      forceLeave(state){
        return state.forceLeave;
      }
    }
  })

  export default store;